import axios from 'axios'

const API_BASE_URL = process.env.ROOT_API

const api = axios.create({
  baseURL: API_BASE_URL
})
const getToken = () => {
  console.log(localStorage.getItem('token'))
  return localStorage.getItem('token')
}
api.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
const login = async (username, password) => {
  return api.post('/login', { username, password })
}

const generalStatus = async () => {
  return api.get('/generalStatus')
}

const regresiones = async (symbol) => {
  return api.get(`/regresiones?symbol=${symbol}`)
}

const historicalc = async (symbol, avgNum) => {
  return api.get(`/historicalc?symbol=${symbol}&interval=1h&avgNum=${avgNum}&start=${1619848800000}&end=${new Date().getTime()}`)
}

const getOpertions = async (symbol) => {
  return api.get(`/getOpertions?symbol=${symbol}&type=long&avgNum=4&interval=1h&start=${1619848800000}&end=${new Date().getTime()}`)
}

export { login,
  generalStatus,
  regresiones,
  historicalc,
  getOpertions
}



// WEBPACK FOOTER //
// ./src/services/multiSnifferService.js